import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { select } from '@panel/commons/core/themev2';
import { useTranslation } from 'react-i18next';

const Retry = ({ actionsToRetry, postingId, height, bottom }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <Container>
      <Wrapper bottom={bottom} height={height} data-panel='retry-container'>
        <ErrorMessage data-panel='retry-message'>{t('panel.desempeno.retry.mensaje')}</ErrorMessage>
        <RetryButton
          data-panel='retry-button'
          onClick={() => actionsToRetry.map(action => dispatch(action(postingId)))}
        >
          {t('panel.desempeno.retry.cargar')}
        </RetryButton>
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: white;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${props => (props.bottom ? 'flex-end' : 'space-between')};
  align-items: center;
  background-color: white;
  height: ${props => (props.height ? props.height : 'fit-content')};
`;

const ErrorMessage = styled.div`
  font-family: 'Hind';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  text-align: center;
  min-width: 137px;
  max-width: 143px;
  white-space: break-spaces;
`;

const RetryButton = styled.button`
  font-family: 'Hind';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  color: ${select('orange')};
  background-color: none;
  border: none;
  cursor: pointer;
`;

export default Retry;
